import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../tailwind.config';

export const CrmActivityPerson: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['gray-40'], background = theme.colors['white'] }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 3.75C10.245 3.75 11.25 4.755 11.25 6C11.25 7.245 10.245 8.25 9 8.25C7.755 8.25 6.75 7.245 6.75 6C6.75 4.755 7.755 3.75 9 3.75ZM4.5 11.985C5.4675 13.44 7.125 14.4 9 14.4C10.875 14.4 12.5325 13.44 13.5 11.985C13.4775 10.4925 10.4925 9.675 9 9.675C7.5 9.675 4.5225 10.4925 4.5 11.985Z"
        fill={fill}
      />
    </svg>
  )
);
